import { InjectionToken } from '@angular/core';
export const CORE_CONFIG_FRONTEND = /*#__PURE__*/new InjectionToken('CORE_CONFIG_FRONTEND');